import React from 'react';
import TreeView from '@zippytech/react-toolkit/TreeView';
import '@zippytech/react-toolkit/TreeView/index.css';
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';
import { Grid } from 'semantic-ui-react';
import LabelWithCount from '../../../common/LabelWithCount';
@source({
  mouseEnter: (props, component) => {
    dispatch.app.setHelpContext(props.name);
  }
})

class ContentTreeView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      currentPath: "1",
      selectedId: this.props.selectedTreeId ? this.props.selectedTreeId : 9,
      underReviewCount: 0
    };
    this.onSelectionChange = this.onSelectionChange.bind(this);
  }


  nodeStyle = (nodeProps) => {
    // if(this.props.match.url === `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_ct`) {
    //   return { color: '#6b6b6b', fontFamily: 'montserrat-normal', fontWeight: 'normal' }
    // }
    if (this.state.selectedId === nodeProps.node.id) {
      return { color: '#7FC4FA', fontFamily: 'montserrat-semibold' }
    } else {
      return { color: '#6b6b6b', fontFamily: 'montserrat-normal', fontWeight: 'normal' }

    }
  }


  async onSelectionChange(selectedMap) {
    dispatch.content.setTreeNode(selectedMap.node.name)
    dispatch.content.setTreeNodeSelected(!this.props.treeNodeSelected)
    const history = this.props.history;
    let subCategoryArr = null;
    let nameArr = []
    let scope;
    let indexPathValue;

    let iPath = selectedMap.indexPath.split('/')[0];
    if (iPath === "1") {
      scope = "Private";
      indexPathValue = "knowledgeBank"
    } else if (iPath === "2") {
      scope = "Public";
      indexPathValue = "publicKnowledgeBank"
    } else {
      scope = null
      indexPathValue = "knowledgeBank"
    }
    if (this.state.currentPath !== selectedMap.path) {
      this.setState({ currentPath: selectedMap.path });
      dispatch.content.setTreeCurrentPath(selectedMap.path);
    }
    await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
    await dispatch.content.openResourcePane(null);
    dispatch.lifeCycle.activePage('');
    this.setState({ selectedId: selectedMap.node.id })
    let pathName;
    if (selectedMap.node.name === 'knowledgeBank' || selectedMap.node.name === 'publicKnowledgeBank') {
      pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_ct/status/${selectedMap.node.name}`;
    }
    else {
      if (selectedMap.node.baseCategory) {
        pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_ct/status/${indexPathValue}/${selectedMap.node._id}`;
      }
      else if (selectedMap.node.category) {
        pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_ct/status/${indexPathValue}/${selectedMap.node.parent.split('/')[0]}/${selectedMap.node._id}`;
      }
      else if (selectedMap.node.subCategory) {
        let subCategoryArr = [];
        if (iPath === "1") {
          subCategoryArr = this.props.categoryTree[selectedMap.path.split('/')[1]].nodes[selectedMap.path.split('/')[2]].nodes.filter((f, i) => f.name !== "Others");
        } else if (iPath === "2") {
          subCategoryArr = this.props.categoryPublicTree[selectedMap.path.split('/')[1]].nodes[selectedMap.path.split('/')[2]].nodes.filter((f, i) => f.name !== "Others");
        }
        nameArr = []

        for (let i = 0; i < subCategoryArr.length; i++) {
          nameArr.push(subCategoryArr[i].name)
        }
        pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_ct/status/${indexPathValue}/${selectedMap.node.parent.split('/')[0]}/${selectedMap.node.parent.split('/')[1]}/${selectedMap.node._id}`;
      }
      else {
        pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_ct/status/${selectedMap.node.name ? selectedMap.node.name : selectedMap.node.name}`
      }
    }

    if (selectedMap.node.name === 'knowledgeBank') {
      await dispatch.categories.getCategoryTreeByAccess({ "accountId": this.props.match.params.accountId, access: "Private" });
    } else if (selectedMap.node.name === 'publicKnowledgeBank') {
      await dispatch.categories.getCategoryTreeByAccess({ "accountId": this.props.match.params.accountId, access: "Public" });
    } else {
      await dispatch.categories.getCategoryTreeByAccess({ "accountId": this.props.match.params.accountId, access: "all" });
    }

    // dispatch.app.setContentPath(pathName);
    history.push({
      pathname: pathName
    });

      let query = {
        $sort: this.props.tableFilterQuery.$sort,
        $skip: 0,
        $limit: this.props.tableFilterQuery.$limit,
        scope: scope,
        subCategoryArr: nameArr
      }
      await dispatch.app.setTableFilterQuery({
        ...query,
      });
      let payload = {
        query: query,
        params: this.props.routeParams
      }

      await dispatch.content.getContentListData(payload)

  }




  componentWillMount() {
    dispatch.lifeCycle.getCategoryTreeAsync({ accountId: this.props.match.params.accountId });
    dispatch.lifeCycle.getPublicCategoryTreeAsync();
    dispatch.content.getContentsCount({ organizationId: this.props.match.params.workspaceId })
    let pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_ct/status/`;
    if(pathName+"in_development"==this.props.location.pathname){
      this.setState({ selectedId: 2 })
    }else if(pathName+"published"==this.props.location.pathname){
      this.setState({ selectedId: 3 })
    }else if(pathName+"reviewRequest"==this.props.location.pathname){
      this.setState({ selectedId: 6 })
    }else if(pathName+"forreview"==this.props.location.pathname){
      this.setState({ selectedId: 5 })
    }else if(pathName+"approved"==this.props.location.pathname){
      this.setState({ selectedId: 7 })
    }
  }

  componentWillReceiveProps(newProps) {
    let pvtTotalCount = 0
    let publicTotalCount = 0
    if (this.props.categoryTree !== newProps.categoryTree) {
      newProps.categoryTree.map((m, i) => {
        pvtTotalCount = pvtTotalCount + m.totalContentCount

        m.label = <LabelWithCount label={m.label} count={m.totalContentCount} />
        if (m.nodes && m.nodes.length !== 0) {
          m.nodes.map((m1, i) => {
            m1.label = <LabelWithCount label={m1.label} count={m1.totalContentCount} />
            if (m1.nodes && m1.nodes.length !== 0) {
              m1.nodes.map((m2, i) => {
                m2.label = <LabelWithCount label={m2.label} count={m2.totalContentCount} />
                return m2
              })
            }
            return m1
          })
        }
        return m
      })
      this.setState({ pvtTotal: pvtTotalCount })
      this.setState({ pvtCategory: newProps.categoryTree })
    }

    if (this.props.categoryPublicTree !== newProps.categoryPublicTree) {
      newProps.categoryPublicTree.map((m, i) => {
        publicTotalCount = publicTotalCount + m.totalContentCount
        m.label = <LabelWithCount label={m.label} count={m.totalContentCount} />
        if (m.nodes && m.nodes.length !== 0) {
          m.nodes.map((m1, i) => {
            m1.label = <LabelWithCount label={m1.label} count={m1.totalContentCount} />
            if (m1.nodes && m1.nodes.length !== 0) {
              m1.nodes.map((m2, i) => {
                m2.label = <LabelWithCount label={m2.label} count={m2.totalContentCount} />
                return m2
              })
            }
            return m1
          })
        }
        return m
      })
      this.setState({ publicTotal: publicTotalCount })
      this.setState({ publicCategory: newProps.categoryPublicTree })
    }
    this.setState({selectedId:newProps.selectedTreeId})
  }
  
  componentDidUpdate(prevProps) {
    const { contentCountData, selectedOrganisation } = this.props;

    if (
      contentCountData !== prevProps.contentCountData ||
      selectedOrganisation !== prevProps.selectedOrganisation
    ) {

      if (
        contentCountData &&
        contentCountData.underReview &&
        selectedOrganisation &&
        selectedOrganisation.role === 'workspaceOwner'
      ) {
        this.setState({ underReviewCount: contentCountData.underReview });
      } else {
        this.setState({
          underReviewCount:
            (contentCountData && contentCountData.reviewReq) ||
            (contentCountData.forReview
              ? contentCountData.reviewReq + contentCountData.forReview
              : 0),
        });
      }
    }
  }


  render() {
    const { underReviewCount } = this.state;
    let inDevelopmentLabelWithCount = <LabelWithCount label="In Design" count={this.props.contentCountData && this.props.contentCountData.inDevelopment ? this.props.contentCountData.inDevelopment : 0} />;
    let publishedLabelWithCount = <LabelWithCount label="Published" count={this.props.contentCountData && this.props.contentCountData.published ? this.props.contentCountData.published : 0} />;
    let underReviewLabelWithCount = <LabelWithCount label="Review request" count={this.props.contentCountData && this.props.contentCountData.underReview ? this.props.contentCountData.underReview : 0} />;
    let ReviewByTeamLabelWithCount = <LabelWithCount label="Sent" count={this.props.contentCountData && this.props.contentCountData.reviewReq ? this.props.contentCountData.reviewReq : 0} />;
    let reviewByMeLabelWithCount = <LabelWithCount label="Received" count={this.props.contentCountData && this.props.contentCountData.forReview ? this.props.contentCountData.forReview : 0} />;
    let ApprovedLabelWithCount = <LabelWithCount label="Approved" count={this.props.contentCountData && this.props.contentCountData.approved ? this.props.contentCountData.approved : 0} />;

    let totalCount = this.props.contentCountData ? this.props.contentCountData.inDevelopment + this.props.contentCountData.published + this.props.contentCountData.reviewReq + this.props.contentCountData.forReview +this.props.contentCountData.approved : 0;

    const treeList = [
      {
        label: <strong> <LabelWithCount labelClass="bg-blue" label="Content Development Library" count={totalCount} /></strong>,
        name: 'contentLibrary',
        id: 1,
        nodes: [
          {
            label: inDevelopmentLabelWithCount,
            name: 'in_development',
            id: 2,
          },
          {
            label: publishedLabelWithCount,
            name: 'published',
            id: 3,
          },
          {
            label: ApprovedLabelWithCount,
            name: 'approved',
            id: 7,
          },
          {
            label: underReviewLabelWithCount,
            name: 'under_review',
            id: 4,
            nodes: [
              {
                label: reviewByMeLabelWithCount,
                name: 'forreview',
                id: 5,
              },
              {
                label: ReviewByTeamLabelWithCount,
                name: 'reviewRequest',
                id: 6,
              },
            ]
          },
          {
            label: `Cloned / Purchased`,
            name: 'clonedorpurchased',
            disabled: true,
            id: 8,
          },

        ]
      },
      {
        label: <strong> <LabelWithCount labelClass="bg-blue" label="Workspace Library" count={this.state.pvtTotal} /></strong>,
        name: 'knowledgeBank',
        nodes: this.state.pvtCategory,
        id: 9,
      },
    ];
        if(this.props.selectedOrganisation.publicLibraryAccess){
          treeList.push(
            {
              label: <strong> <LabelWithCount labelClass="bg-blue" label="Public Library" count={this.state.publicTotal} /> </strong>,
              name: 'publicKnowledgeBank',
              nodes: this.state.publicCategory,
              id: 10,
            }
          )
        }

    return (


      <Grid divided className="practiceTree " >
        <Grid.Row className="pad_0" style={{
          height: "100%",
          overflow: "auto"
        }}>
          <Grid.Column
            className="w_100"
            style={{ height: "100%", overflow: "auto", padding: "0" }}
          >
            <TreeView
              leafNodeIcon={
                <svg fill="#000000" height="16" viewBox="0 0 24 24" width="22" style={{ verticalAlign: 'middle', overflow: 'inherit' }}>
                  <path d="M 0 10 20 10" stroke="#F6F6F6" strokeWidth="1" fill="none" />
                </svg>
              }
              className="browserPane tree-ellipsis"
              enableSelection={true}
              nodeStyle={this.nodeStyle}
              onSelectionChange={(selectedMap) => { this.onSelectionChange(selectedMap) }}
              dataSource={treeList}
              singleSelect={true}
              defaultCollapsedDepth={1}
              enableHoverStyle={false}
              enableKeyboardNavigation={false}
            />
          </Grid.Column>

        </Grid.Row>
      </Grid>

    );
  }
}
export default ContentTreeView;
